<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" :placeholder="$t('verify.PhoneNumber1')" @input="setInput()">
            <template  slot="prepend">
              <span>{{ruleForm.nationCode}}</span>
              <el-select class="login_flag"  v-model="ruleForm.nationCode" :placeholder="$t('SelectCountryRegion')" @change='changeLocation'>
                <el-option v-for="(item,index) in nationList" :key="index" :label="item.NationCode" :value="item.NationCode">
                  <div class="locationOption">
                    <img :src="item.IconUrl">
                    <span>{{$i18n.locale!='zh'?item.EnName:item.ChName}}</span>
                  </div>
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <div class="codeText">
          <el-form-item class="login_form_item" prop="code">
            <el-input class="login_ipt codeIpt" v-model="ruleForm.code" :placeholder="$t('verify.VerificationCode')" @input="setInput()"></el-input>
          </el-form-item>
          <el-button class="login_btn codeBtn" :disabled='isCode' type="primary" @click="getCode('ruleForm')">{{codeText}}</el-button>
        </div>
        <el-form-item class="login_form_item" prop="oldpassword">
          <el-input class="login_ipt" v-model="ruleForm.oldpassword" :type="flagType" maxlength='20' :placeholder="$t('verify.Password')" @input="setInput('oldpassword')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" maxlength='20' :placeholder="$t('verify.ConfirmNewPassword')" @input="setInput('password')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">{{$t('Confirm')}}</el-button>
        <div class="returnLogin">{{$t('verify.AlreadyAccount')}}<span @click="godialog('login','forgot')">{{$t('SignIn')}}</span></div>
        <!-- <div class="userText U25">登录或注册即代表同意 <router-link :to="{path:'/'}">用户协议</router-link> 和 <router-link :to="{path:'/'}">隐私政策</router-link>
        </div> -->
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { isEmoji } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    var newPassAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('verify.ConfirmNewPassword')));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$t('verify.PasswordDoNotMatch')));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      times: 60,
      flagType: 'password',
      flag: false,
      codeText: this.$t('SendCode'),
      isCode: true,
      disabled: true,
      dialogClass: 'user',
      nationList: '',
      ruleForm: {
        nationCode: '+86',
        mobile: '',
        password: '',
        code: '',
        oldpassword: ''
      },
      rules: {
        oldpassword: [
          { required: true, message: this.$t('verify.Password'), trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('verify.WordCount'),trigger: 'blur'},
        ],
        mobile: [
          { required: true, message: this.$t('verify.PhoneNumber1'), trigger: 'blur' },
          { pattern: /^\+?[1-9]\d{1,14}$/, message: this.$t('verify.PhoneNumber1'),trigger: 'blur'},
        ],
        password: [
          { validator: newPassAgain, trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('verify.VerificationCode'), trigger: '' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    that.getNationList()
    this.handleKeydown = (e) => {
      if (!this.disabled && e.keyCode === 13) {
        this.submitForm('ruleForm')
      }
    }
    window.addEventListener('keydown', this.handleKeydown)
    //console.log(this.$interface.SignIn)
  },
  beforeDestroy() {
    if (this.handleKeydown) {
      window.removeEventListener('keydown', this.handleKeydown)
    }
  },
  methods: {
    getNationList() {
      let that = this;
      let data = { PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetNationList, data).then(res => {
        if (res.Result != 0) {
          that.nationList = countries(res.Data) 
        }
      })
    },
    
    changeLocation(e) {
      let that = this
      that.nationList.map(res => {
        
        if (res.Code == e) {
          that.ruleForm.nationCode=res.NationCode
          //that.LocationIcon = res.IconUrl
        }
      })
    },
    // 点击快捷跳转 忘记密码 和 注册
    godialog(toval,val){
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    // 获取验证码
    getCode(formName) {
      let that = this;
      that.isCode = true;
      this.$refs[formName].validateField('mobile', (val) => {
        if (val == "") {
          that.isCode = true;
          if (that.times == 60) {
            that.codeText = that.times+'s';
          }
          that.timer = setInterval(() => {
            that.times--;
            that.codeText = that.times+'s';
            if (that.times === 0) {
              that.times = 60;
              that.codeText = this.$t('SendCode');
              that.isCode = false;
              clearInterval(that.timer);
            }
          }, 1000);
          
          var Nation = that.ruleForm.nationCode
            if (Nation.indexOf('+') > -1) {
              Nation = Nation.slice(1)
            }
          let data = {
            NationCode:Nation,
            mobile: that.ruleForm.mobile,
            type: 2
          }
          this.$post(this.$interface.SendMobileCode,data).then(res=>{
            if(res.Result!=0){
            }else{
              that.times = 60;
              that.codeText = this.$t('SendCode');
              that.isCode = false;
              clearInterval(that.timer);
              this.$message.error(res.Msg);
            }
          }).catch({})
        }else{
          that.isCode = true
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('closeDialog', 'forgot', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      console.log(this.flag, this.flagType)
    },
    // 判断input是否有值
    setInput(val) {
      this.$refs['ruleForm'].validateField('mobile',(val) => {
        if (val == "") {
        this.isCode = false
        }else{
        this.isCode = true
        }
      })
      // if (this.ruleForm.mobile != ''){
      //   this.isCode=false
      // }else{
      //   this.isCode=true
      // }
      if (val == 'oldpassword'|| val == 'password') {
        this.ruleForm[val] = isEmoji(this.ruleForm[val], 1)
      }
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '' && this.ruleForm.oldpassword != '' && this.ruleForm.code != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 登入
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading=true;
          that.disabled=true;
          that.ruleForm.NewPassword=that.ruleForm.password
          let data=that.ruleForm
          
          var Nation = that.ruleForm.nationCode
            if (Nation.indexOf('+') > -1) {
              Nation = Nation.slice(1)
              data.nationCode=Nation
            }
          that.$post(that.$interface.ResetPassword,data).then(res=>{
            if(res.Result!=0){
              that.$message.success(that.$t('verify.ChangesSaved'));
              that.closeDialog()
              that.$emit('godialog', 'login', true)
            }else{
              that.disabled = false
              that.$message.error(res.Msg);
            }
            that.loading=false;
          }).catch({})
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

/deep/ .login_flag input{
  width: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/forgot.vue